<template>
  <ul class="questions__steps">
    <li
      class="question__step"
      v-for="(mode, index) in bulletsProp"
      :key="index + mode.status"
    >
      <Bullet :mode="mode.status" />
    </li>
  </ul>
</template>

<script>
import Bullet from "./Bullet";
export default {
  name: "BulletList",
  components: {
    Bullet
  },
  props: ["bullets"],
  computed: {
    bulletsProp() {
      return this.bullets;
    }
  }
};
</script>

<style lang="scss" scoped>
.questions__steps {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.question__step {
  margin: 0 5px;

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
}
</style>
